import type { IUseCase } from '@/shared/contracts/use-case.contract';
import type { IHttpClient } from '@/shared/contracts/http-client.contract';
import { HttpMethod } from '@/shared/contracts/http-client.contract';

import { UIError } from '@/shared/utils/ui-error';

import { ENDPOINT } from '../types/get-order';
import type { Order } from '../types/order';

type UseCaseInput = {
  id_order: string;
};

export type VerifyPaymentResult = 'paid' | 'pending' | 'not_paid' | 'no_charge' | 'busy';

export type VerifyPaymentResponse = {
  verification: VerifyPaymentResult;
  message: string;
  order: Order;
};

/**
 * PRAT-193: "Verificar pagamento". Pede para a API consultar o PIX no banco e,
 * se estiver pago, corrigir o pedido na hora (o que estava como "Erro no
 * pagamento" passa a aguardar a loja aceitar).
 */
export class VerifyPaymentUseCase implements IUseCase<UseCaseInput, VerifyPaymentResponse> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<VerifyPaymentResponse> {
    if (!input.id_order) {
      throw new UIError('ORDER_NOT_FOUND', 'Pedido não encontrado.');
    }

    return this.client.sendRequest<VerifyPaymentResponse, never>({
      endpoint: `${ENDPOINT}/${input.id_order}/verify-payment`,
      method: HttpMethod.POST,
    });
  }
}
